import { CircleQuestionMark } from "lucide-react";

import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { openSupport } from "../../helpers/helpers";
import { useSupportUnread } from "../../hooks/useSupportUnread";

/** Sidebar row above the account menu: opens the support Messenger. */
export function NavSupport() {
  const unread = useSupportUnread() > 0;
  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        tooltip="Support"
        aria-label={unread ? "Support, unread reply" : "Support"}
        data-testid="nav-support"
        onClick={() => openSupport()}
      >
        <span className="relative inline-flex shrink-0">
          <CircleQuestionMark className="size-4" />
          {unread ? (
            <span
              aria-hidden
              data-testid="nav-support-unread-dot"
              className="absolute -top-0.5 -right-0.5 size-2 rounded-full bg-primary ring-1 ring-sidebar"
            />
          ) : null}
        </span>
        <span className="truncate">Support</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
